import React from 'react';
import _ from 'lodash';

import { useNetSuiteBrandSelectFieldQuery } from 'generated/graphql';



export interface INetSuiteBrand {
  id: string;
  displayName: string;
}

export interface IData {
  objects: INetSuiteBrand[];
}

export function useQuery() {
  const queryTuple = useNetSuiteBrandSelectFieldQuery();

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.netSuiteBrands ?? [], (node): INetSuiteBrand => ({
        id: node.id,
        displayName: node.name
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}
